import { z } from 'zod';

const requiredString = (
  requiredError: string,
  invalidTypeError: string,
  buildSchema?: (schema: z.ZodString) => z.ZodString
) =>
  z.preprocess(
    (value) => (value == null ? '' : value),
    (buildSchema
      ? buildSchema(
          z.string({
            required_error: requiredError,
            invalid_type_error: invalidTypeError,
          })
        )
      : z.string({
        required_error: requiredError,
        invalid_type_error: invalidTypeError,
      }))
      .min(1, requiredError)
  );

export const formSchema = z
  .object({
    carrier_id: requiredString(
      'Selecione a transportadora',
      'Selecione a transportadora'
    ),
    vehicle_type_id: requiredString(
      'Tipo do veículo é obrigatório',
      'Tipo do veículo deve ser um number'
    ),
    vehicle_subtype_id: requiredString(
      'SubTipo do veículo é obrigatório',
      'SubTipo do veículo deve ser um number'
    ),
    vehicle_plate: requiredString(
      'Placa do veículo é obrigatória',
      'Placa do veículo deve ser uma string',
      (schema) =>
        schema.max(50, 'Placa do veículo deve ter no máximo 50 caracteres')
    ),
    tag_id: z
      .string({
		required_error: 'Tag é obrigatória',
        invalid_type_error: 'Tag deve ser um number',
      }),
    //   .optional(),

    qtd_eixos: requiredString(
      'Quantidade de Eixo é obrigatório',
      'Quantidade de Eixo deve ser uma string'
    ),
    qtd_eixos_suspenso: requiredString(
      'Quantidade de Eixo Suspenso é obrigatório',
      'Quantidade de Eixo suspenso deve ser uma string'
    ),

    // renavam: z
    //   .string({
    //     invalid_type_error: 'Renavam deve ser uma string',
    //   })
    //   .optional(),
    // manufacture_year: z
    //   .string({
    //     invalid_type_error: 'Ano de fabricação deve ser uma string',
    //   })
    //   .max(10, 'Ano de fabricação deve ter no máximo 10 caracteres')
    //   .optional(),
    // vehicle_brand_id: z
    //   .string({
    //     invalid_type_error: 'Marca do veículo deve ser um number',
    //   })
    //   .optional(),
    // vehicle_model_id: z
    //   .string({
    //     invalid_type_error: 'Modelo do veículo deve ser um number',
    //   })
    //   .optional(),
    // color: z
    //   .string({
    //     invalid_type_error: 'Cor deve ser uma string',
    //   })
    //   .min(1, 'Cor é obrigatória')
    //   .optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.vehicle_type_id === '2' &&
      (!data.tag_id || data.tag_id === '')
    ) {
      ctx.addIssue({
        path: ['tag_id'],
        message: 'Tag é obrigatória para veículos do tipo "Não Articulado"',
        code: z.ZodIssueCode.custom,
      });
    }
  });
